import Dashboard from "../Pages/Dashboard/Dashboard";
import GuestEmployee from "../Pages/EmployeeManagement/GuestEmployee";
import EmployeeStatus from "../Pages/EmployeeManagement/EmployeeStatus";
import Setting from "../Pages/Configuration/Setting";
import DocumentVerification from "../Pages/EmployeeManagement/DocumentVerification";
import AssignShiftes from "../Pages/EmployeeManagement/AssignShiftes";
import ApprovedEmployees from "../Pages/EmployeeManagement/ApprovedEmployees";
import Letters from "../Pages/EmployeeManagement/Letters";
import LetterHead from "../Pages/LetterManagement/LetterHead";
import LetterHeadList from "../Pages/LetterManagement/LetterHeadList";
import Department from "../Pages/Masters/Department";
import Designation from "../Pages/Masters/Designation";
import EmployeeDocumentTypes from "../Pages/Masters/EmployeeDocumentTypes";
import Grades from "../Pages/Masters/Grades";
import Locations from "../Pages/Masters/Locations";
import CandidateDetailsList from "../Pages/EmployeeManagement/CandidateDetailsList";
import SalrayHeade from "../Pages/Masters/SalrayHeade";
import SalrayStatutory from "../Pages/Masters/SalaryStatutory";
import Profile from "../Pages/EmployeeProfileDetails/Profile";
import Documents from "../Pages/EmployeeProfileDetails/Documents";
import CandidateLetters from "../Pages/EmployeeProfileDetails/CandidateLetters";
import SalaryDetails from "../Pages/EmployeeProfileDetails/SalaryDetails";
import NewLetter from "../Pages/LetterManagement/NewLetter";
import LetterList from "../Pages/LetterManagement/LetterList";
import LeaveType from "../Pages/Masters/LeaveType";
import LeaveTypeList from "../Pages/Masters/LeaveType";
import Agencies from "../Pages/Masters/Agencies";
import UpdateEmployee from "../Pages/EmployeeManagement/ManageEmployee/UpdateEmployee";
import CandidateBackgroundVerification from "../Pages/EmployeeManagement/BackgroundVerification";
import NewPayroll from "../Pages/PayrollManagement/NewPayroll";
import PayrollSessions from "../Pages/PayrollManagement/PayrollSessions";
import PayrollSettings from "../Pages/PayrollManagement/Payroll Setting/PayrollSetting";
import OverTime from "../Pages/Masters/OverTime";
import BackgroundVerified from "../Pages/EmployeeManagement/BackgroundVerified";
import Calendar from "../Pages/Masters/Calendar";
import CalendarFestivals from "../Pages/Masters/CalendarFestivals";
import CalendarWeeklyOff from "../Pages/Masters/CalendarWeeklyOff";
import Shiftes from "../Pages/Masters/Shiftes";
import ManageWorkExperience from "../Pages/EmployeeManagement/ManageEmployee/ManageWorkExperience";
import ManageEducationDetails from "../Pages/EmployeeManagement/ManageEmployee/ManageEducationDetails";
import ManageBankDetails from "../Pages/EmployeeManagement/ManageEmployee/ManageBankDetails";
import ManageDocumentDetails from "../Pages/EmployeeManagement/ManageEmployee/ManageDocumentDetails";
import ManagePersonalDetails from "../Pages/EmployeeManagement/ManageEmployee/ManagePersonalDetails";
import ManageLevelsDetails from "../Pages/EmployeeManagement/ManageEmployee/ManageLevelsDetails";
import ManageFamilyDetails from "../Pages/EmployeeManagement/ManageEmployee/ManageFamilyDetails";
import UpdatePayroll from "../Pages/PayrollManagement/ManagePayroll/UpdatePayroll";
import ManageEmployeeList from "../Pages/PayrollManagement/ManagePayroll/ManageEmployeeList";
import ManageHeads from "../Pages/PayrollManagement/ManagePayroll/ManageHeads";
import LeaveCategory from "../Pages/Masters/LeaveCategory";
import OTLogs from "../Pages/Masters/OTLogs";
import ApprovedLeave from "../Pages/LeaveManagement/ApprovedLeave";
import RejectedLeave from "../Pages/LeaveManagement/RejectedLeave";
import AcceptedLeave from "../Pages/LeaveManagement/AcceptedLeave";
import ManageHeadesAndStatutory from "../Pages/PayrollManagement/ManagePayroll/ManageHeadesAndStatutory";
import ManageAttendence from "../Pages/PayrollManagement/ManagePayroll/ManageAttendence";
import ManageOverTime from "../Pages/PayrollManagement/ManagePayroll/ManageOverTime";
import ManageLeaves from "../Pages/PayrollManagement/ManagePayroll/ManageLeaves";
import Leaveapply from "../Pages/EmployeeProfileDetails/Leaveapply";
import AttendenceDashboard from "../Pages/Attendences/AttendenceDashboard"
import AttendenceReport from "../Pages/Attendences/AttendenceReport"
import GeneralSettings from "../Pages/Attendences/AttendanceSetting/GeneralSettings"
import RegularizationSettings from "../Pages/Attendences/AttendanceSetting/RegularizationSettings"
import AttendenceRegularization from "../Pages/Attendences/AttendenceRegularization"
import Attendencesummary from "../Pages/Attendences/Attendencesummary";
import EmployeeCategory from "../Pages/Masters/EmployeeCategory";
import EmployeeType from "../Pages/Masters/EmployeeType";
import ManageStatutoryDetails from "../Pages/EmployeeManagement/ManageEmployee/ManageStatutoryDetails";
import AttendanceMuster from "../Pages/Attendences/AttendanceMuster";
import OTSummaryReport from "../Pages/Attendences/OTSummaryReport";
import AssignRM from "../Pages/EmployeeManagement/AssignRM";
import ShifteList from "../Pages/Masters/ShifteList";
import EmployeeOnboard from "../Pages/EmployeeManagement/EmployeeOnboard";
import LeaveGeneralSettings from "../Pages/LeaveManagement/LeaveGeneralSettings";
import LeaveTemplateSettings from "../Pages/LeaveManagement/LeaveTemplateSettings";
import LeaveTypeSandBox from "../Pages/LeaveManagement/LeaveTypeSandBox";
import States from "../Pages/Masters/States";
import LeaveDataImporting from "../Pages/LeaveManagement/LeaveDataImporting";
import PayrollHeadCreate from "../Pages/PayrollManagement/PayrollHeadCreate";
import PayrollHeadMaster from "../Pages/PayrollManagement/PayrollHeadMaster";
import StatutorySlabMaster from "../Pages/PayrollManagement/StatutorySlabMaster";
import StatutorySlab from "../Pages/PayrollManagement/StatutorySlab";
import LockAttendanceAndLeave from "../Pages/PayrollManagement/LockAttendanceAndLeave";
import OrderListEditor from "../Pages/PayrollManagement/OrderListEditor";
import PayrollAttendance from "../Pages/PayrollManagement/PayrollAttendance";
import PayrollOtherHeadImport from "../Pages/PayrollManagement/PayrollOtherHeadImport";
import PayrollOtherHeadInput from "../Pages/PayrollManagement/PayrollOtherHeadInput";
import PayrollProcess from "../Pages/PayrollManagement/PayrollProcess";
import HeaderMaster from "../Pages/Masters/HeaderMaster";
import SalaryReport from "../Pages/PayrollManagement/SalaryReport";
import NewLetterSandBox from "../Pages/LetterManagement/NewLetterSandBox";
import PublishPayslip from "../Pages/PayrollManagement/PublishPayslip";
import CreateMail from "../Pages/LetterManagement/CreateMail";
import MailList from "../Pages/LetterManagement/MailList";
import GuestEmployeeSandBox from "../Pages/EmployeeManagement/GuestEmployeeSandBox";
import OfferLetterSentList from "../Pages/EmployeeManagement/OfferLetterSentList";
import Signature from "../Pages/Masters/Signatory/Signature";
import SignatureList from "../Pages/Masters/Signatory/SignatureList";
import CandidateInfoCollection from "../Pages/EmployeeManagement/CandidateInfoCollection";
import SentAppointmentLetter from "../Pages/EmployeeManagement/SentAppointmentLetter";
import PolicyMaster from "../Pages/Masters/PolicyMaster";
import NewPolicy from "../Pages/Masters/NewPolicy";
import InductionProcess from "../Pages/EmployeeManagement/InductionProcess";
import ComplianceReports from "../Pages/PayrollManagement/Compliance/ComplianceReports";
import Page404 from "../Layout/Page404";
import PMSCycle from "../Pages/Masters/PMSCycle";
import EmployeeGoalReport from "../Pages/EmployeeManagement/PMS/EmployeeGoalReport";
import OffboardingSettings from "../Pages/Offboarding/OffboardingSettings";
import EmailBox from "../Pages/LetterManagement/EmailBox";
import ExpenseMaster from "../Pages/Masters/ExpenseMaster";
import UserCreate from "../Pages/Masters/UserCreate";
import AssignModule from "../Pages/Masters/AssignModule";
import EditSalaryHeadOrder from "../Pages/PayrollManagement/EditSalaryHeadOrder";
import AssignLeaves from "../Pages/EmployeeManagement/AssignLeaves";
import AssignAttendanceCaptureMode from "../Pages/EmployeeManagement/AssignAttendanceCaptureMode";
import PaySlips from "../Pages/PayrollManagement/PaySlips";
import EmployeeOffboard from "../Pages/Offboarding/EmployeeOffboard";
import OffboardingLogs from "../Pages/Offboarding/OffboardingLogs";
import AssignPolicy from "../Pages/EmployeeManagement/AssignPolicy";
import SendBulkLetters from "../Pages/LetterManagement/SendBulkLetters";
import AllLogs from "../Pages/AllLogs/AllLogs";
import HelpAndSupport from "../Pages/HelpAndSupport/HelpAndSupport";
// import BiometricAttendanceImport from "../Pages/Attendences/BiometricAttendanceImport";
import DraftLetters from "../Pages/EmployeeManagement/DraftLetters";
import PayslipsOld from "../Pages/PayrollManagement/PayslipsOld";
import LeaveHistoryImporting from "../Pages/LeaveManagement/LeaveHistoryImporting";
import PolicyReport from "../Pages/EmployeeManagement/PolicyReport";
import BankMaster from "../Pages/Masters/BankMaster";
import SalaryBankFile from "../Pages/PayrollManagement/SalaryBankFile";
import AttendanceMusterReport from "../Pages/Attendences/AttendanceMusterReport";



// routes.js
const routes = [
  ////////////////////// Login Routing ///////////////////////////

  // { path: "/Login/:master_program_id?", element: <Login/> },

  ////////////////////// Dashboard Routing ///////////////////////////
  { path: "/", element: <Dashboard /> },

  { path: "/AllLogs", element: <AllLogs />},

  ////////////////////// Employee Management Routing ///////////////////////////
  // { path: "/GuestEmployee/:master_program_id?", element: <GuestEmployee /> },

  // 'GuestEmployee' route is used in Dashboard.js.
  // If you update this route, make sure to update it in Dashboard.js file as well.
  { path: "/GuestEmployee/:master_program_id?", element: <GuestEmployeeSandBox /> },
  
  { path: "/OfferLetterSentList/:master_program_id?", element: <OfferLetterSentList /> },
  { path: "/EmployeeStatus/:master_program_id?", element: <EmployeeStatus /> },
  { path: "/CandidateInfoCollection/:master_program_id?", element: <CandidateInfoCollection /> },
  { path: "/SentAppointmentLetter/:master_program_id?", element: <SentAppointmentLetter /> },
  { path: "/InductionProcess", element: <InductionProcess /> },
  {
    path: "/DocumentVerification/:master_program_id?",
    element: <DocumentVerification />,
  },

  {
    path: "/BackgroundVerification/:master_program_id?",
    element: <CandidateBackgroundVerification />,
  },

  { path: "/AssignShiftes/:master_program_id?", element: <AssignShiftes />, },
  { path: "/AssignRM", element: <AssignRM />, },
  { path: "/AssignLeaves", element: <AssignLeaves />, },
  { path: "/AssignAttendanceCaptureMode", element: <AssignAttendanceCaptureMode />, },
  { path: "/PolicyPublish", element: <AssignPolicy />, },


  { path: "/Letters/:master_program_id?", element: <Letters /> },
  { path: "/Letters/:master_program_id?", element: <Letters /> },

  ////////////////////// Update Employee Routing ///////////////////////////
  { path: "/Employee/UpdateEmployee/:employee_id?", element: <UpdateEmployee /> },
  { path: "/Employee/WorkExperience/:employee_id?", element: <ManageWorkExperience /> },
  { path: "/Employee/EducationalDetails/:employee_id?", element: <ManageEducationDetails /> },
  { path: "/Employee/BankDetails/:employee_id?", element: <ManageBankDetails /> },
  { path: "/Employee/IdDetails/:employee_id?", element: <ManageDocumentDetails /> },
  { path: "/Employee/PersonalDetails/:employee_id?", element: <ManagePersonalDetails /> },
  { path: "/Employee/StatutoryDetails/:employee_id?", element: <ManageStatutoryDetails /> },
  { path: "/Employee/LevelDetails/:employee_id?", element: <ManageLevelsDetails /> },
  { path: "/Employee/FamilyDetails/:employee_id?", element: <ManageFamilyDetails /> },
  { path: "/EmployeeGoalsReport", element: <EmployeeGoalReport /> },

  { path: "/GeneralSettings", element: <GeneralSettings /> },
  ////////////////////// Payroll Management Routing ///////////////////////////
  { path: "/NewPayroll", element: <NewPayroll /> },
  { path: "/PayrollSessions", element: <PayrollSessions /> },
  { path: "/PayrollGeneralSettings", element: <PayrollSettings /> },
  { path: "/PayrollSessions/Heads&Statutory/:employee_id?", element: <ManageHeadesAndStatutory employee_id={33} /> },
  { path: "/PayrollSessions/Leaves/:employee_id?", element: <ManageLeaves /> },
  { path: "/OverTime/:master_program_id?", element: <OverTime /> },
  { path: "/PayrollSessions/OverTime/:employee_id?", element: <ManageOverTime /> },
  { path: "/PayrollSessions/Attendence/:employee_id?", element: <ManageAttendence /> },
  { path: "/Attendencesummary/:employee_id?", element: <Attendencesummary /> },
  { path: "/LockAttendanceAndLeave/:employee_id?", element: <LockAttendanceAndLeave /> },
  { path: "/PayrollHeadMaster", element: <PayrollHeadMaster /> },
  { path: "/CreatePayrollHead", element: <PayrollHeadCreate /> },
  { path: "/StatutorySlabMaster", element: <StatutorySlabMaster /> },
  { path: "/StatutorySlab", element: <StatutorySlab /> },
  { path: "/PayrollHeadOrderEdit/:employee_id?", element: <OrderListEditor /> },
  { path: "/PayrollAttendance/:employee_id?", element: <PayrollAttendance /> },
  { path: "/PayrollOtherHeadImport/:employee_id?", element: <PayrollOtherHeadImport /> },
  { path: "/PayrollOtherHeadInput/:employee_id?", element: <PayrollOtherHeadInput /> },

  // 'PayrollProcess' route is used in SalaryReport.jsx.
  // If you update this route, make sure to update it in SalaryReport.jsx file as well.
  { path: "/PayrollProcess/:employee_id?", element: <PayrollProcess /> },

  { path: "/Employee/EmployeeList/:employee_id?", element: <UpdatePayroll /> },
  { path: "/Employee/Heads/:employee_id?", element: <UpdatePayroll /> },

  // 'SalaryReport' route is used in PayrollProcess.jsx and Dashboard.js.
  // If you update this route, make sure to update it in PayrollProcess.jsx and Dashboard.js files as well.
  { path: "/SalaryReport/:employee_id?", element: <SalaryReport /> },

  { path: "/PublishPayslip/:employee_id?", element: <PublishPayslip /> },
  { path: "/Payslips", element: <PaySlips /> },
  { path: "/PayslipsOld", element: <PayslipsOld /> },
  { path: "/HeaderMaster/:employee_id?", element: <HeaderMaster /> },
  { path: "/ComplianceReports", element: <ComplianceReports /> },
  { path: "/SalaryBankFile", element: <SalaryBankFile /> },

  ////////////////////// Update Payroll Management Routing ///////////////////////////
  { path: "/Employee/UpdatePayroll/:employee_id?", element: <UpdatePayroll /> },
  { path: "/Employee/ManageEmployeeList/:employee_id?", element: <ManageEmployeeList /> },
  { path: "/Employee/ManageHeads/:employee_id?", element: <ManageHeads /> },



  ////////////////////// Letter Management Routing ///////////////////////////

  // { path: "/NewLetter", element: <NewLetter /> },
  { path: "/NewLetter/:company_letter_id", element: <NewLetter /> },
  { path: "/NewLetter", element: <NewLetter /> },
  { path: "/NewLetterSandBox", element: <NewLetterSandBox /> },
  { path: "/BackgroundVerified", element: <BackgroundVerified /> },
  { path: "/LetterList", element: <LetterList /> },
  { path: "/Agencies", element: <Agencies /> },
  { path: "/LeaveCategory", element: <LeaveCategory /> },
  { path: "/ShifteList", element: <ShifteList /> },
  { path: "/Shiftes/:company_location_shift_id?", element: <Shiftes /> },
  { path: "/EmailTemplateList", element: <MailList/> },
  { path: "/CreateEmail", element: <CreateMail/> },
  { path: "/EmailBox", element: <EmailBox/> },



  ////////////////////// Master Management Routing ///////////////////////////
  { path: "/Departments/:master_program_id?", element: <Department /> },

  { path: "/Designation/:master_program_id?", element: <Designation /> },

  { path: "/EmployeeDocumentTypes/:master_program_id?", element: <EmployeeDocumentTypes /> },

  { path: "/Grades/:master_program_id?", element: <Grades /> },
  { path: "/States", element: <States /> },

  { path: "/Locations/:master_program_id?", element: <Locations /> },
  { path: "/SalrayHeade/:master_program_id?", element: <SalrayHeade /> },

  { path: "/SalrayStatutory/:master_program_id?", element: <SalrayStatutory /> },
  
  { path: "/OTLogs/:master_program_id?", element: <OTLogs /> },
  { path: "/Calendar/:master_program_id?", element: <Calendar /> },
  { path: "/CalendarFestivals/:master_program_id?", element: <CalendarFestivals /> },
  { path: "/CalendarWeeklyOff/:master_program_id?", element: <CalendarWeeklyOff /> },
  { path: "/PMSCycle", element: <PMSCycle /> },
  { path: "/LeaveType", element: <LeaveType /> },

  { path: "/LeaveTypeList", element: <LeaveTypeList /> },
  { path: "/EmployeeType", element: <EmployeeType /> },
  { path: "/EmployeeCategory", element: <EmployeeCategory /> },
  { path: "/PolicyMaster", element: <PolicyMaster /> },
  { path: "/NewPolicy", element: <NewPolicy /> },
  { path: "/SignatoryMaster", element: <SignatureList /> },
  { path: "/NewSignatoryMaster/:signatory_id?", element: <Signature /> },
  { path: "/ExpenseMaster", element: <ExpenseMaster /> },
  { path: "/UserCreate", element: <UserCreate/> },
  { path: "/AssignModule", element: <AssignModule/> },
  { path: "/PolicyReport", element: <PolicyReport/> },
  { path: "/BankMaster", element: <BankMaster/> },
  ////////////////////// Employee Onboarding Routing ///////////////////////////
  // 'EmployeeOnboarding' route is used in Dashboard.js.
  // If you update this route, make sure to update it in Dashboard.js file as well.
  { path: "/EmployeeOnboarding/:master_program_id?", element: <EmployeeOnboard /> },

  { path: "/EmployeeOffboard", element: <EmployeeOffboard /> },
  { path: "/OffboardingLogs", element: <OffboardingLogs /> },

  ////////////////////// Employee Enrollment Routing ///////////////////////////
  { path: "/ApprovedEmployees/:master_program_id?", element: <ApprovedEmployees /> },
  { path: "/AcceptedLeave/:master_program_id?", element: <AcceptedLeave /> },
  { path: "/RejectedLeave/:master_program_id?", element: <RejectedLeave /> },

  ////////////////////// Attendence Management Routing ///////////////////////////
  { path: "/AttendenceDashboard", element: <AttendenceDashboard /> },

  // 'AttendanceReport' route is used in Dashboard.js.
  // If you update this route, make sure to update it in Dashboard.js file as well.
  { path: "/AttendanceReport", element: <AttendenceReport /> },

  { path: "/AttendanceMuster", element: <AttendanceMuster /> },
  { path: "/AttendanceMusterReport", element: <AttendanceMusterReport /> },
  { path: "/AttendenceRegularization", element: <AttendenceRegularization /> },
  { path: "/OTSummaryReport", element: <OTSummaryReport /> },
  { path: "/RegularizationSettings", element: <RegularizationSettings /> },
  { path: "/LeaveGeneralSettings", element: <LeaveGeneralSettings /> },
  { path: "/LeaveTypeSandBox", element: <LeaveTypeSandBox /> },
  // { path: "/BiometricAttendanceImport", element: <BiometricAttendanceImport/> },

  ////////////////////// leave Management Routing ///////////////////////////
  // 'ApprovedLeave' route is used in Dashboard.js.
  // If you update this route, make sure to update it in Dashboard.js file as well.
  { path: "/ApprovedLeave/:master_program_id?", element: <ApprovedLeave /> },
  
  { path: "/LeaveTemplateSettings/:master_program_id?", element: <LeaveTemplateSettings /> },
  { path: "/LeaveDataImporting/:master_program_id?", element: <LeaveDataImporting /> },
  { path: "/LeaveHistoryImporting", element: <LeaveHistoryImporting /> },


  ////////////////////// Reports Routing ///////////////////////////

  ////////////////////// Configuration Routing ///////////////////////////
  { path: "/Setting", element: <Setting /> },
  { path: "/LetterHead/:company_letter_head_id?", element: <LetterHead /> },
  { path: "/LetterHeadList", element: <LetterHeadList/> },
  { path: "/SendBulkLetters", element: <SendBulkLetters/> },


  ////////////////////// SubmitedLists Routing ///////////////////////////
  { path: "/CandidateDetailsList/:master_program_id?", element: <CandidateDetailsList /> },

  { path: "/Profile/:employee_id?", element: <Profile /> },
  { path: "/Documents/:employee_id?", element: <Documents /> },
  { path: "/CandidateLetters/:employee_id?", element: <CandidateLetters /> },
  { path: "/Leaveapply/:employee_id?", element: <Leaveapply /> },

  { path: "/SalaryDetails/:employee_id?", element: <SalaryDetails /> },
  { path: "*", element: <Page404/> },



  ////////////////////// Ful, And Final Routing ///////////////////////////
  { path: "/OffboardingSettings", element: <OffboardingSettings/> },
  { path: "/HelpAndSupport", element: <HelpAndSupport /> },





];

export default routes;

export const otherRoutes=[
  "GuestEmployee",
  "AttendenceRegularization",
  "LetterHeadList",
  "LetterList",
  "CandidateDetailsList",
  "SignatoryMaster",
  "PolicyMaster",
  "EmailTemplateList",
  "PayrollHeadMaster",
  "StatutorySlabMaster",
  "SalaryReport",
  "ShifteList",
];

export const offerLetterSentForm=[
  { path: "/DraftLetters", element: <DraftLetters /> },
]
export const attendanceRoutes=[
  { path: "/AttendenceDashboard/:employee_id", element: <AttendenceDashboard /> },
]
export const shiftsRoutes=[
  { path: "/Shiftes/:company_location_shift_id?", element: <Shiftes /> },
]
export const updateEmaployeeRoutes=[
  { path: "/Employee/UpdateEmployee/:employee_id?", element: <UpdateEmployee /> },
  { path: "/Employee/WorkExperience/:employee_id?", element: <ManageWorkExperience /> },
  { path: "/Employee/EducationalDetails/:employee_id?", element: <ManageEducationDetails /> },
  { path: "/Employee/BankDetails/:employee_id?", element: <ManageBankDetails /> },
  { path: "/Employee/IdDetails/:employee_id?", element: <ManageDocumentDetails /> },
  { path: "/Employee/PersonalDetails/:employee_id?", element: <ManagePersonalDetails /> },
  { path: "/Employee/StatutoryDetails/:employee_id?", element: <ManageStatutoryDetails /> },
  { path: "/Employee/LevelDetails/:employee_id?", element: <ManageLevelsDetails /> },
  { path: "/Employee/FamilyDetails/:employee_id?", element: <ManageFamilyDetails /> },  
];

export const letterMasterRoutes=[
  { path: "/NewLetter/:company_letter_id", element: <NewLetter /> },
  { path: "/NewLetter", element: <NewLetter /> },
];
export const letterHeadRoutes=[
  { path: "/LetterHead/:company_letter_head_id?", element: <LetterHead /> },
];
export const signatoryRoutes=[
  { path: "/NewSignatoryMaster/:signatory_id?", element: <Signature /> },
];
export const policyMasterRoutes=[ 
  { path: "/NewPolicy", element: <NewPolicy /> },
];
export const emailMasterRoutes=[
  { path: "/CreateEmail", element: <CreateMail/> },
];
export const payrollRoutes=[
  { path: "/CreatePayrollHead", element: <PayrollHeadCreate /> },
  { path: "/PayrollHeadOrderEdit/:employee_id?", element: <OrderListEditor /> },
  { path: "/StatutorySlab", element: <StatutorySlab /> },
];
export const slabRoutes=[
  { path: "/StatutorySlab", element: <StatutorySlab /> },
];
export const salaryRegisterRoutes=[
  { path: "/EditSalaryHeadOrder", element: <EditSalaryHeadOrder/> },
];
